/**
 * 缓存说明:字典缓存
 */
import vm from '@/cache/storeTools.js'
import enumApi from '@/components/api/enumApi.js'

var basestate = {
	enumTree: undefined,
	valueTypeList: [{
			name: '文本',
			value: 'Varchar'
		}, {
			name: '长文本',
			value: 'Text'
		}, {
			name: '整数',
			value: 'Int'
		}, {
			name: '小数',
			value: 'Float'
		}, {
			name: '长整数',
			value: 'Long'
		}
		//	,{
		//		name:'大数',
		//		value:'Bigint'
		//	}
		, {
			name: '日期',
			value: 'Date'
		}, {
			name: '日期时间',
			value: 'DateTime'
		}, {
			name: '是否',
			value: 'Boolean'
		}
	]
	//	,{
	//		name:'字典',
	//		value:'Enum'
	//	}]
}

var store = new vm.Vuex.Store({
	state: copy(basestate),
	getters: {
		getEnumTree(state, getters) {
			if(state.enumTree == undefined) {
				store.commit("getEnumTree")
				return []
			}
			return state.enumTree
		},
		getEnumByEnumCode(state, getters) {
			return enumCode => {
				var Enum = getters.getEnumTree.find(item => {
					return item.enumcode == enumCode
				})
				return Enum == undefined ? {} : Enum
			}
		},
		getValueTypeNameByValueType(state) {
			return valueType => {
				if(valueType == undefined || valueType == null || valueType == '') {
					return '- -'
				}
				return state.valueTypeList.find(item => {
					return item.value == valueType
				}).name
			}
		}
	},
	mutations: {
		clear() {
			//清理缓存
			store.replaceState(copy(basestate))
		},
		getEnumTree(state) {
			enumApi.getEnumTree(respon => {
				vm.Vue.set(state, 'enumTree', respon)
			})
		}
	}
});

//对外提供
export default store

/**
 * 需要分页的内容,以数组存储全部,取的时候进行分页,
 * 刷新时获取指定页数据,然后合并,重复的数据以新的为准,
 * 可能会导致缺失遗漏,但是有清理缓存就可以了
 */